import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { withStyles, makeStyles, useTheme, styled } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { BreadcrumbPage } from "../../shared";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import EllipsisText from "react-ellipsis-text";
import axios from "axios";
import { getRequest, postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { CommonCss } from "../../services/CommonCss";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import CancelIcon from '@mui/icons-material/Cancel';
import ClearIcon from '@mui/icons-material/Clear';
import {
  FormGroup,
  FormLabel,
  FormControl,
  ListItemText,
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem
} from '@mui/material';

import { cookieKeys, getCookie } from "../../services/Cookies";
import {
  FormHelperText,
  Input,
  Radio,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import { ThemeProvider } from "@mui/styles";
import MUIDataTable from "mui-datatables";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { Crop169 } from "@mui/icons-material";
const getMuiTheme = () => createTheme({

  overrides: {
    MUIDataTableHeadCell: {
      root: {
        textTransform: "none"
      }
    }
  }
})
const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
    borderRadius: 8,
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  txtInput: {
    "& input": {
      padding: "4px 8px",
      fontWeight: 600,
    },
    "& fieldset": {},
  },
  breadcrumbBox: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle3: {
    borderRadius: "12px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "2px 11px",
    alignItems: "right"
  },
  moveinput: {
    marginRight: "100px",
  },
  link: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
      color: "#ff4717"
    }

  },
  link2: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    // '&:hover': {
    //   "text-decoration": "underline",
    //   cursor: "pointer",
    //   background: "none",
    //   color: "#ff4717"
    // }

  },
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 25
    }
  },
  link1: {
    textTransform: "capitalize",
    color: "#006400 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
    }

  },
  link3: {
    textTransform: "capitalize",
    color: "#006400 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    // '&:hover': {
    //   "text-decoration": "underline",
    //   cursor: "pointer",
    //   background: "none",
    //}

  },


}));

export default function BunkerAlert() {
  let theme = createTheme();
  theme = responsiveFontSizes(theme)
  const dispatch = useDispatch();
  const classesCommonCss = CommonCss();
  const BreadcrumbList = [{ name: "Bunker Alert", url: "" }];
  const classes = useStyles();
  const history = useHistory();
  const [BunkerAlertData, setBunkerAlertData] = useState([]);
  const [supplierFilter, setSupplierFilter] = useState([]);
  const [productFilter, setProductFilter] = useState([]);
  const [bargeFilter, setBargeFilter] = useState([]);
  const [testParamFilter, settestParamFilter] = useState([]);
  const [fName, setFName] = useState("");
  const [pdfURL, setPdfURL] = useState("");
  const [openpdf, setOpenpdf] = React.useState(false);
  const getAllBunkerAlertDate = () => {
    //
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/GetBunkerAlertData`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          let sup = [];
          let bargeFilter = [];
          let testParam = [];
          let product = [];
          res.data.forEach((d) => {
            d.date = moment(d.date).format('DD/MM/YYYY');
            d?.supplier !== null ? sup.push(...d?.supplier.split(",")) : sup.push(...[]);
            d?.bargeName !== null ? bargeFilter.push(...d?.bargeName.split(",")) : bargeFilter.push(...[]);
            d?.testParameter !== null ? testParam.push(...d?.testParameter.split(",")) : testParam.push(...[]);
            d?.fuelGrade !== null ? product.push(...d?.fuelGrade.split(",")) : product.push(...[]);
            setSupplierFilter([...new Set(sup)]);
            setProductFilter([...new Set(product)]);
            setBargeFilter([...new Set(bargeFilter)]);
            settestParamFilter([...new Set(testParam)]);

          })
          setBunkerAlertData(res.data);
        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        ToastError(error.response.data.message);
        dispatch({ type: LOADING, payload: false });
      });
  }
  useEffect(() => {
    getAllBunkerAlertDate();

  }, []);
  /*
  const filtLogic=(val, filters) => {
    if (filters.length) return !filters.includes(val);
    retun fralse;
   
    
  }*/

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 850,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: "strong",
      border: '1px solid #dadde9',
    },
  }));
  
  const filtLogic = (val, filters) => {
    //
    let retValue = true;
    if (filters.length == 0)
      retValue = false;
    filters.forEach((filt) => {
      if (val?.indexOf(filt) > -1)
        retValue = false;
    })

    return retValue;


  }


  const columns = [
    {
      name: "year",
      label: "Year",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "bA_No",
      label: "BA No",
      options: {
        filter: true,
        sort: false,

      }
    }, {
      name: "date",
      label: "Date",
      options: {
        filter: true,
        sort: true,
        /* filterOptions: {
 
           renderValue: (value) => {
             return <Moment format="DD/MM/YYYY">{value}</Moment>
           }
         },
         customBodyRender: (value) => {
           //;
           let datearr = [];
           let date = new Date(value);
 
           let dateString = moment(value).format('DD/MM/YYYY');
           datearr.push(dateString);
           //return <Moment format="DD/MM/YYYY">{value}</Moment>
           return datearr
         },
         customFilterListOptions: {
           render: (v) => {
             return <Moment format="DD/MM/YYYY">{v}</Moment>
           }
         },*/
      }
    }, {
      name: "subject",
      label: "Subject",
      options: {
        filter: true,
        sort: false,

      }
    }, {
      name: "region",
      label: "Region",
      options: {
        filter: true,
        sort: false,

      }
    },
    {
      name: "country",
      label: "Country",
      options: {
        filter: true,
        sort: false,

      }
    }, {
      name: "port",
      label: "Port",
      options: {
        filter: true,
        sort: false,

      }
    }, {
      name: "mainport",
      label: "Main Port",
      options: {
        filter: true,
        sort: false,

      }
    }, {
      name: "testParameter",
      label: "Test Parameter",
      options: {
        filter: true,
        sort: false,
        // filterList:testParamFilter
        filterType: 'custom',
        filterOptions: {
          logic: filtLogic,
          display: (filterList, onChange, index, column) => {
            const optionValues = testParamFilter;
            return (
              <FormControl variant="filled" >
                <InputLabel htmlFor='select-multiple-chip'>
                  Test Parameter
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={selected => selected.join(', ')}
                  onChange={event => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color='primary'
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }
        }
      }
    }, {
      name: "fuelGrade",
      label: "Product",
      options: {
        filter: (getCookie("userRole") == "VPS Admin" ? true : false),
        sort: false,
        //filterList:productFilter,
        display: (getCookie("userRole") == "VPS Admin" ? true : "excluded"),
        filterType: 'custom',
        filterOptions: {
          logic: filtLogic,
          display: (filterList, onChange, index, column) => {
            const optionValues = productFilter;
            return (
              <FormControl variant="filled" >
                <InputLabel htmlFor='select-multiple-chip'>
                  Product
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={selected => selected.join(', ')}
                  onChange={event => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color='primary'
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }
        }
      }
    }, {
      name: "supplier",
      label: "Supplier",

      options: {
        filter: (getCookie("userRole") == "VPS Admin" ? true : false),
        sort: false,
        // filterList:supplierFilter,
        display: (getCookie("userRole") == "VPS Admin" ? true : "excluded"),
        filterType: 'custom',
        filterOptions: {
          logic: filtLogic,
          display: (filterList, onChange, index, column) => {
            const optionValues = supplierFilter;
            return (
              <FormControl variant="filled" >
                <InputLabel htmlFor='select-multiple-chip'>
                  Supplier
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={selected => selected.join(', ')}
                  onChange={event => {//
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color='primary'
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }
        }

      }

    }, {
      name: "bargeName",
      label: "Barge Name",
      options: {
        filter: (getCookie("userRole") == "VPS Admin" ? true : false),
        sort: false,
        //  filterList:bargeFilter,
        display: (getCookie("userRole") == "VPS Admin" ? true : "excluded"),
        filterType: 'custom',
        filterOptions: {
          logic: filtLogic,
          display: (filterList, onChange, index, column) => {
            //
            const optionValues = bargeFilter;
            return (
              <FormControl variant="filled" >
                <InputLabel htmlFor='select-multiple-chip'>
                  Barge Name
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={selected => selected.join(', ')}
                  onChange={event => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color='primary'
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }
        }
      }
    }, {
      name: "filepath",
      label: "Download",
      options: {
        filter: false,
        sort: false,
        download:false,
        customBodyRender: (Value, tableMeta) => {

          return(
            <HtmlTooltip
              title={
                <React.Fragment>
                  <EllipsisText text={BunkerAlertData[tableMeta.rowIndex].filepath} length={200} />
                </React.Fragment>
              }
            >
             <button class="col-4" style={{ border: "none", background: "none", width: "10px", padding: "20px" }}  onClick={() => { loadPdfFile(BunkerAlertData[tableMeta.rowIndex].filepath, "click") }}><img src="/assets/images/F-icon.png" style={{ width: "20px" }}  /> </button>
            </HtmlTooltip>
        )    
      }
      }
    },
    {
      name: "Edit",
      label: "	Actions",
      options: {
        filter: false,
        sort: false,
        download:false,
        display: (getCookie("userRole") == "VPS Admin" ? true : "excluded"),
        customBodyRender: (Value, tableMeta) => {

          // if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "No") {
         //   (reportData[tableMeta.currentTableData[tableMeta.rowIndex].index])
          return <button className={classes.link} onClick={() => {   onEditUserDetails(BunkerAlertData[tableMeta.currentTableData[tableMeta.rowIndex].index])  }}>Edit </button>
          // } else if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "Yes") {
          // return <button className={classes.link2} /*onClick={() => { onEditUserDetails(registeredUsers[tableMeta.rowIndex], 1) }}*/>Edit </button>
          // }
        }
      }
    },];
  const onEditUserDetails = (obj) => {
    //
    //history.push("/dashboard/admin/edit-user/" + obj.username);  path="/dashboard/editBunkerAlert/:id"
    history.push("/dashboard/editBunkerAlert/" + obj.id);

  }
  const handleClose = () => {

    //setOpenAlert(false);
    setOpenpdf(false)
  };
  const[BunkerDownload,SetBunkerDownload]=useState([]);
  const options = {
    customToolbarSelect:()=>{
      <>
      onRowsDelete:True,
      </>
      
    },
    selectToolbarPlacement:"above",
    selectableRows:"multiple",
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    },
    onRowSelectionChange:(currentRowsSelected,allRowsSelected,rowsSelected)=>{
   
      let isExist=[];
      rowsSelected.forEach((d)=>{
      isExist.push(BunkerAlertData[d]);
      console.log("isExsit",isExist);
      console.log("BunkerAlertData",BunkerAlertData);
    })
  
    SetBunkerDownload(isExist)
  },
  onDownload:(buildHead, buildBody,columns, gridData)=>{
    debugger
    var myData= [];
    var idx = 0;
    var columnsExport = [];
    columnsExport.push("");
    
    columns.forEach((cl) => {
      if(cl.label!=="\tActions")
      columnsExport.push(cl.label);

    })
    // newKeys.forEach((k) => {
    //   columnsExport.push(k);
    // });
    columnsExport.push("\n");
    let i = 0;

    //console.log(item);
   BunkerDownload.length > 0 ?
      (
        BunkerDownload.forEach((item) => {
          let visibleRows = gridData.filter((df) => {
            console.log("gridData",gridData);
            let dfdt = df.data;
            if (dfdt[0] == item.year && dfdt[1] == item.bA_No)
              return true;
            else
              return false;

          });
          if (visibleRows.length > 0) {

            let itemData = { ...item };
            let dataItem = []
            if (i == 0)
              dataItem.push("");
            i++;
            
            itemData.testParameter=itemData.testParameter.replace(/,/g,"");
            itemData.fuelGrade=itemData.fuelGrade.replace(/,/g,"");
            itemData.supplier=itemData.supplier.replace(/,/g,"");
            itemData.bargeName=itemData.bargeName.replace(/,/g,"");

            let objsample={
              Year:itemData.year,
              BA_NO:itemData.bA_No,
              Date:itemData.date,
              Subject:itemData.subject,
              Region:itemData.region,
              countrty:itemData.country,   
              Port:itemData.port,
              Mainport: itemData.mainport,
              TestParameter:itemData.testParameter,
              Product: itemData.fuelGrade,
              Supplier: itemData.supplier,
              bargeName: itemData.bargeName,
              Pdf:itemData.filepath,
             }
             let objsample1={
              Year:itemData.year,
              BA_NO:itemData.bA_No,
              Date:itemData.date,
              Subject:itemData.subject,
              Region:itemData.region,
              countrty:itemData.country,   
              Port:itemData.port,
              Mainport: itemData.mainport,
              TestParameter:itemData.testParameter,
              Pdf:itemData.filepath,
             }

            let data = [];
            if(getCookie("userRole") == "VPS Admin")
   {
      data.push(...Object.values({ ...objsample}));
   }
   if(getCookie("userRole") !== "VPS Admin")
   {
      data.push(...Object.values({ ...objsample1}));
   }
            data.push("\n");
            dataItem.push(data);
            // });
            myData.push(...dataItem);
            // console.log("myData",myData)
          }
        })
      ) :(
        BunkerAlertData.forEach((item) => {
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;
              if (dfdt[0] == item.year && dfdt[1] == item.bA_No)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {

              let itemData = { ...item };
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;  
              
              // itemData.testParameter=itemData.testParameter.replace(/,/g,"");
              // itemData.fuelGrade=itemData.fuelGrade.replace(/,/g,"");
              // itemData.supplier=itemData.supplier.replace(/,/g,"");
              // itemData.bargeName=itemData.bargeName.replace(/,/g,"");

              let objsample={
              Year:itemData.year,
              BA_NO:itemData.bA_No,
              Date:itemData.date,
              Subject:itemData.subject,
              Region:itemData.region,
              countrty:itemData.country,   
              Port:itemData.port,
              Mainport: itemData.mainport,
              TestParameter:itemData.testParameter,
              Product: itemData.fuelGrade,
              Supplier: itemData.supplier,
              bargeName: itemData.bargeName,
              Pdf:itemData.filepath,
             }

            let data = [];
            data.push(...Object.values({ ...objsample }));
            data.push("\n");
            dataItem.push(data);
            // });
            myData.push(...dataItem);
            // console.log("myData",myData)
          }
        })

      )
buildHead = () => {
console.log(columnsExport);
return columnsExport;
}
buildBody = () => {
// console.log(myData);
return  myData;
}
return buildHead() + buildBody();
  }
  };
  const loadPdfFile = (data) => {
    //
    setFName(data);
    dispatch({ type: LOADING, payload: true });
    const token = getCookie("token");
  //let filepath=data.trim()

    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `BunkerAlerts/downloadFile`;
    let filedata = JSON.stringify({ "fileName": data });
    let config = {
      method: "post",
      responseType: "blob",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/pdf"
      },
      data: filedata,
    };
    axios(config)
      .then(async function (response) {
        //;
        if (response.status == 200) {
          //;
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //var link = document.createElement('a');
          //link.href = fileURL;
          setPdfURL(fileURL);
          setOpenpdf(true)
          //document.body.appendChild(link);
          //link.click();
          //window.open(fileURL,'_blank');
          //setOpenBunkerAlerts(fileURL);
        } else {
          ToastError(response.data.message);
        }
      })
      .catch(function (error) {
        //;
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  };
  return (
    <>
      <div>
        <Dialog
          /*  fullWidth={} */
          maxWidth="xl"
          fullWidth
          maxWidth="sm"
          open={openpdf}
        //onClose={handleClose}

        >
          <DialogContent>
            {pdfURL ? (
              <iframe
                src={`${pdfURL}#page=1&toolbar=0`}
                //src={`${openBunkerAlerts}#page=1&toolbar=0&statusbar=0&scrollbar=1&height=100%`}
                // frameborder="0"
                // height={window.screen.height-280}
                width="100%"
                //  height={window.screen.height+"px"}
                // style={{"height":`${window.screen.height-280}px`}}
                style={{ "min-height": '100%' }, { "height": `${window.screen.height - 90}px` }}
              ></iframe>
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions>
            <a href={`${pdfURL}#page=1&toolbar=0`} download={fName} style={{ textDecoration: "none" }}>

              <Button>Download</Button></a>
            <Button onClick={() => { handleClose(true) }}> <CancelIcon /></Button>
          </DialogActions>

        </Dialog>
        {/* <Box component="main" px={3} pb={0} display="flex">
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Box display="dlock">
              <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpen}/>}/>
            </Box>
          </Grid>
        </Grid>
            </Box> */}
      </div>
      <Box component="main" mx={3} mt={3}>
        <Box className={classes.boxLayout}>
          <Box
            display="dlock"
            bgcolor="#1a1a31"
            className={classes.breadcrumbBox}
          >
            <BreadcrumbPage rows={BreadcrumbList} />
          </Box>
          <Box
            display="flex"
            className={classesCommonCss.justifyContentBetween}
            alignItems="center"
            px={3}
            pt={3}
            pb={5}
          >
            {getCookie("userRole") == "VPS Admin" ?
              <Box component="span" width="310px"    >
                <Button
                  className={classes.btnStyle2}

                  onClick={() => {
                    history.push("/dashboard/AddBunkerAlert");
                  }}
                >
                  Add Bunker Alert
                </Button>
              </Box>
              : ""}
          </Box>
          <Box className="reportstablehead" pb={5} px={1}>

            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title={"Bunker Alert List"}
                //data={getData()}
                data={BunkerAlertData}
                className={classes.tableBody}
                columns={columns}
                options={options}
              />

            </ThemeProvider>
          </Box>
        </Box>
      </Box>
    </>
  );
}
